module.exports = __webpack_public_path__ + "img/user_bg_account.90ace7e5.png";